import React from 'react';

const ExperienceSection = () => {
  return (
    <section className="py-5 bg-colorr">
      <div className="container">
        <div className="row align-items-center justify-content-between">

          {/* Image and overlay block */}
          <div className="col-xl-5 col-lg-5 col-md-6 mb-4 mb-md-0">
            <div className="position-relative">
              <img
                src="/img/img-2.png"
                className="img-fluid rounded-3 position-relative z-1"
                alt="Skyline Cabs Experience"
              />
              <div className="position-absolute bottom-0 start-0 z-index-1 mb-4 ms-2">
                <div className="bg-white d-inline-flex rounded-3 position-relative p-3 z-2 shadow-wrap">

                  {/* Avatar group */}
                  <div className="me-4">
                    <h6 className="fw-normal mb-1">Clients</h6>
                    <ul className="avatar-group list-unstyled d-flex mb-0">
                      {/* {["team-1", "team-2", "team-3", "team-4"].map((img, index) => (
                        <li key={index} className="avatar avatar-md me-1">
                          <img className="avatar-img circle" src={`/img/${img}.jpg`} alt="client" />
                        </li>
                      ))} */}
                      <li className="avatar avatar-md">
                        <div className="avatar-img circle bg-primary text-white d-flex align-items-center justify-content-center">
                          <span className="small">40K+</span>
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* Rating */}
                  <div>
                    <h6 className="fw-normal mb-2">Rating</h6>
                    <h6 className="m-0 fw-bold">
                      4.8
                      <i className="fa-solid fa-star text-warning ms-1"></i>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Text content block */}
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="bestExperience-block">
              <p className="fw-medium text-white text-uppercase mb-2">Trusted Ride</p>
              <h2 className="fw-bold lh-base mb-3">
                Enjoy Seamless & Comfortable Cab Rides With Skyline Cabs
              </h2>
              <p className="text-white fs-6">
                Skyline Cabs has been delivering top-quality, reliable, and comfortable travel experiences for over 3 decades. 
                Whether it’s a daily commute, an airport transfer, or a long-distance ride — we’ve got you covered with professional drivers and well-maintained vehicles.
              </p>
              <div className="d-flex flex-wrap mt-4 gap-3">
                <div className="d-flex flex-column align-items-center p-3 rounded  bg-lightt border">
                  <h6 className="fw-bold fs-3 m-0">13+</h6>
                  <p className="m-0 small text-white">Years of Service</p>
                </div>
                <div className="d-flex flex-column align-items-center p-3 rounded  bg-lightt border">
                  <h6 className="fw-bold fs-3 m-0">120+</h6>
                  <p className="m-0 small text-white">City Connections</p>
                </div>
                <div className="d-flex flex-column align-items-center p-3 rounded bg-lightt border">
                  <h6 className="fw-bold fs-3 m-0">25K+</h6>
                  <p className="m-0 small text-white">Happy Customer</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
